import { useState } from "react";
import { FaCamera, FaPlus } from "react-icons/fa";
import { GrUpdate } from "react-icons/gr";
import { Link } from "react-router-dom";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { toast } from "sonner";
import { EMPLOYER_URL, EVERIFY_API } from "../../resources/resource";
import { uploadToCloudinary } from "../../Utils/cloudinaryUpload";
import DefaultProfile from "../../assets/Images/companyDefault.png";
import TaxDeductionModal from "./TaxDeductionModal";

const ProfileCard = ({ user, refetch }) => {
  const [profilePreview, setProfilePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const makeRequest = useMakeRequest();

  const onAvatarChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Validate file type
    if (!selectedFile.type.startsWith("image/")) {
      toast.error("Please select an image file");
      return;
    }

    setFile(selectedFile);
    const imageUrl = URL.createObjectURL(selectedFile);
    setProfilePreview(imageUrl);
  };

  const handleVerify = () => {
    window.open(EVERIFY_API, "_blank");
  };

  const handleUpdateAvatar = async () => {
    try {
      if (!file) {
        toast.error("Please select an image first");
        return;
      }

      setLoading(true);
      const uploadResult = await uploadToCloudinary(file);
      // console.log("result -->", uploadResult);
      if (!uploadResult) {
        throw new Error("Failed to upload image");
      }

      const payload = {
        avatar: uploadResult,
      };

      await makeRequest(
        `${EMPLOYER_URL}/updateJobEmployer/${user?._id}`,
        "PUT",
        payload,
        (data) => {
          console.log("Update successful:", data);
          refetch();
          if (profilePreview) {
            URL.revokeObjectURL(profilePreview);
          }
          setProfilePreview(null);
          setFile(null);
        },
        (error) => {
          console.error("Update failed:", error);
          toast.error("Failed to update profile picture");
        },
        () => {
          setLoading(false);
        },
        { dontNotifyOnSuccess: false }
      );
    } catch (error) {
      console.error("Avatar update error:", error);
      toast.error("Failed to update profile picture");
      setLoading(false);
    }
  };

  return (
    <div className="bg-white mt-20 rounded-lg shadow-sm overflow-hidden">
      <div className="bg-blue-50 h-32 relative">
        <div className="w-full flex items-center justify-center flex-col p-2">
         <div className=" ">
          <Link
            to={`/${user?._id}/postJob`}
            className="p-2 bg-blue-500 text-sm text-white rounded-lg hover:bg-blue-800 flex items-center"
          >
            <FaPlus className="w-4 h-4 mr-2" />
            Post New Job
          </Link>
        </div>
        
          <p className="text-sm text-neutral-500">
            {/* Connect with everify, where you can manage and verify your employee
            all in one place */}
            post available jobs in your firm or organization and also manage your staff without stress
          </p>
        </div>
        <div className="absolute -bottom-12 left-8 flex items-end space-x-4">
          <div className="relative">
            <img
              src={profilePreview || user?.avatar || DefaultProfile}
              alt="Profile"
              className="w-24 h-24 rounded-xl object-cover border-4 border-white shadow-sm"
            />
            <label
              htmlFor="avatar-upload"
              className="absolute bottom-1 right-1 p-1.5 bg-white rounded-full shadow-md cursor-pointer hover:bg-gray-50 transition-all duration-200"
            >
              <FaCamera className="w-4 h-4 text-gray-600" />
              <input
                id="avatar-upload"
                type="file"
                className="hidden"
                accept="image/*"
                onChange={onAvatarChange}
              />
            </label>
          </div>
          <div className="mb-4">
            <h1 className="text-xl font-semibold text-gray-900">
              {user?.companyName}
            </h1>
            <p className="text-sm text-gray-500">{user?.email}</p>
          </div>
        </div>
          {/* <button
            onClick={handleVerify}
            className="p-2 bg-orange-500 text-sm text-white rounded-md"
          >
            Connect With Everify
          </button>
        */}
      </div>
      {profilePreview && (
        <button
          onClick={handleUpdateAvatar}
          disabled={loading}
          className="absolute flex items-center gap-2 right-10 bg-green-500 text-white px-4 py-[5px] rounded-sm disabled:bg-green-300"
        >
          Update
          <GrUpdate className={loading ? "animate-spin" : ""} />
        </button>
      )}
      <div className="h-16" />
      <TaxDeductionModal/>
    </div>
  );
};

export default ProfileCard;



















